export default __webpack_public_path__ + "static/media/dg-icon.eef67039.svg";